<template>
  <div class="form-field"
       :rel="computedRelName"
       :class="wrapperClasses">
    <div class="form-label" v-show="label">{{ label }}</div>
    <div class="form-hint" v-show="hint">{{ hint }}</div>
    <div class="form-input">
      <div style="display: flex; flex-direction: row" class="form-input-wrapper">

        <textarea
            type="text"
            :name="name"
            :placeholder="placeholder"
            :value="formattedValue"
            :maxlength="maxlength"
            :readonly="isReadonly"
            :disabled="isDisabled"
            :required="isRequired"
            @input="updateValue($event.target.value)"></textarea>

        <span class="suffix" v-if="suffix"><span>{{ suffix }}</span></span>
        <div class="form-translations" v-if="translations && Object.keys(translations).length > 1">
          <Translator @updateValue="updateValue" :translate-key="translateKey" :lang="lang" v-model="translations" />
          <i :class="classLang"><img :src="'/src/assets/flags/'+lang+'.svg'"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Translator from "./Translator.vue";
import ModalLang from './ModalLang.vue'
export default {
  props: {
    components: {Translator},
    name: {
      default: "",
      required: false
    },
    placeholder: {
      default: null,
    },
    value: {
      required: false
    },
    label: {
      default: null
    },
    hint: {
      default: null
    },
    suffix: {
      default: null
    },
    maxlength: {
      default: null
    },
    lang: {
      default: null
    },
    translateKey: {
      default: null
    },
    translations: {
      default: null
    },
    disabled: {
      default: false
    },
    required: {
      default: false
    },
  },
  data: function() {
    return {
      uniqueId: Math.random().toString(36).substr(2, 9),
      action: []
    };
  },
  created: function() {

  },
  computed: {
    wrapperClasses: function() {
      return {'has-suffix': this.suffix, 'form-required': this.isRequired, 'form-readonly': this.isReadonly, 'has-lang': this.lang, 'form-disabled': this.isDisabled};
    },
    classLang: function() {
      return this.lang ? "flag lang-" + this.lang : "";
    },
    computedRelName: function() {
      return this.name ? this.name : this.uniqueId;
    },
    formattedValue: function() {
      return this.value == null ? '' : String(this.value);
    },
    isReadonly: function() {
      return this.readOnly && (this.readOnly == 'true' || this.readOnly == true) ? true : false
    },
    isDisabled: function() {
      return this.disabled && (this.disabled == 'true' || this.disabled == true) ? true : false
    },
    isRequired: function() {
      return this.required && (this.required == 'true' || this.required == true) ? true : false
    }
  },
  methods: {
    updateValue: function(input) {
      var parsed = this.parseValue(input);
      this.$emit('input', parsed); // Synchronisation avec le parent
    },
    parseValue: function(input) {
      if (input.trim() === '') return null; // Convertir "" en null
      if (!isNaN(input) && input.indexOf('.') === -1) return parseInt(input, 10); // Convertir en entier si possible
      return input; // Renvoyer string sinon
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/form/Textarea.vue